function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FeatureTags } from "imagica-corekit/dist/base/domain/project/FeatureTags";
export var InitialReportSize = /*#__PURE__*/_createClass(function InitialReportSize() {
  _classCallCheck(this, InitialReportSize);
  _defineProperty(this, "width", 0);
  _defineProperty(this, "height", 0);
});
export var textAreaValue = /*#__PURE__*/_createClass(function textAreaValue() {
  _classCallCheck(this, textAreaValue);
  _defineProperty(this, "format", void 0);
  _defineProperty(this, "name", void 0);
});
export var CreateBlobUrl = /*#__PURE__*/_createClass(function CreateBlobUrl() {
  _classCallCheck(this, CreateBlobUrl);
  _defineProperty(this, "objectURL", undefined);
  _defineProperty(this, "fileBlob", undefined);
  _defineProperty(this, "loading", undefined);
  _defineProperty(this, "streaming", undefined);
  _defineProperty(this, "unStructuredDownloadFailedText", undefined);
});
export var BaseUploadNodeProps = /*#__PURE__*/_createClass(function BaseUploadNodeProps() {
  _classCallCheck(this, BaseUploadNodeProps);
  _defineProperty(this, "createBlobUrl", new CreateBlobUrl());
  _defineProperty(this, "content", undefined);
  _defineProperty(this, "noWheelClassName", "");
  _defineProperty(this, "initialReportSize", new InitialReportSize());
  _defineProperty(this, "id", "");
  _defineProperty(this, "isStaticApp", false);
  _defineProperty(this, "textAreaValue", new textAreaValue());
  _defineProperty(this, "isStartNode", false);
  _defineProperty(this, "isStartNodeAdded", false);
  _defineProperty(this, "focusNodeTopBarById", void 0);
  _defineProperty(this, "featureTags", new FeatureTags());
  _defineProperty(this, "loading", void 0);
  _defineProperty(this, "changeSizeByIframe", void 0);
  _defineProperty(this, "isShare", false);
  _defineProperty(this, "checkNodeArr", []);
  _defineProperty(this, "isLongPress", false);
  _defineProperty(this, "reloadMap", false);
  _defineProperty(this, "handleCot", function () {});
  _defineProperty(this, "handleBuyStock", void 0);
  _defineProperty(this, "buyStockPermission", void 0);
  /**
   * 修改 textAreaValue
   * @param textAreaValue
   * @returns
   */
  _defineProperty(this, "onChange", function () {});
  /**
   * 修改 整个node data
   * @param data
   */
  _defineProperty(this, "onChangeData", function () {});
  /**
   * for stock node
   */
  _defineProperty(this, "editorId", void 0);
  /**
   * for stock node
   */
  _defineProperty(this, "locus", void 0);
  /**
   * for stock node
   */
  _defineProperty(this, "fontSize", void 0);
  /**
   * for stock node
   */
  _defineProperty(this, "handleImageLoaded", void 0);
  /**
   * 用来储存用户操作相关的数据，这各个节点里面转为真正的类型。
   */
  _defineProperty(this, "userRelatedData", void 0);
  /**
   * 该方法的前身是 reactflow ReactflowState 的 triggerNodeChanges，可使用 useStore 获取
   *
   * 原则上来说，preivew 不应该对 canvas 进行操作, 目前只在 CustomNode 中对 node 增加该回调
   */
  _defineProperty(this, "onNodeChanges", void 0);
});
export var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
export var uploadTypeArr = tuple("uploadFile", "uploadImage", "baseVideo", "unStructured", "table", "pdfFile", "audio", "html");